import React from 'react';
import { Alert, Box, Button } from '@mui/material';
import { ReportPreflightCompanyResult, ReportStatus } from '../../../types/api';

type ReportActionsSectionProps = {
  preflightIssues: ReportPreflightCompanyResult[];
  primaryButtonIsDownloadMode: boolean;
  latestCompletedReport: ReportStatus | null;
  onDownloadReport: (report: ReportStatus) => Promise<void>;
  onGenerateReport: () => Promise<void>;
  loading: boolean;
  isGenerateDisabled: boolean;
  selectedUnitCount: number;
  buttonRefForExplosion: React.RefObject<HTMLButtonElement>;
};

const ReportActionsSection: React.FC<ReportActionsSectionProps> = ({
  preflightIssues,
  primaryButtonIsDownloadMode,
  latestCompletedReport,
  onDownloadReport,
  onGenerateReport,
  loading,
  isGenerateDisabled,
  selectedUnitCount,
  buttonRefForExplosion,
}) => {
  return (
    <>
      {preflightIssues.length > 0 && (
        <Alert severity="warning" sx={{ borderRadius: 2 }}>
          {`Koncernrapporten kan inte starta innan dessa bolag har giltig koppling: ${preflightIssues.map((issue) => `${issue.profileKey}${issue.message ? ` (${issue.message})` : ''}`).join(', ')}`}
        </Alert>
      )}

      <Button
        ref={buttonRefForExplosion}
        variant="contained"
        color={primaryButtonIsDownloadMode ? 'success' : 'primary'}
        onClick={primaryButtonIsDownloadMode ? () => latestCompletedReport && onDownloadReport(latestCompletedReport) : onGenerateReport}
        disabled={primaryButtonIsDownloadMode ? loading : isGenerateDisabled}
        fullWidth
        size="large"
        sx={{
          py: 1.8,
          fontSize: '1.02rem',
          fontWeight: 650,
          borderRadius: 2,
          animation: 'none',
          boxShadow: 'none',
        }}
      >
        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box component="img" src="/gais-makrill.png" alt="" aria-hidden="true" className="makrill-spinner" sx={{ width: 30, height: 30 }} />
            <span>Skapar rapport...</span>
          </Box>
        ) : primaryButtonIsDownloadMode ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <span>Ladda hem rapport</span>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <span>Skapa rapport</span>
          </Box>
        )}
      </Button>

      {selectedUnitCount === 0 && (
        <Alert severity="info" sx={{ mt: 1, borderRadius: 2 }}>
          Välj minst en.
        </Alert>
      )}
    </>
  );
};

export default React.memo(ReportActionsSection);
